<div class="row button-container">
    <div class="col-2 custom-button">
        <div id="AOC-rset-section" *ngIf="isHidden" class="rSet">
            <label aria-hidden="true">
                External Rset
                <input type="checkbox" [checked]="isExternalRset" name="Rset"
                class="primary-checkbox" id="Rset" (change)="rSetChanged($event.target.checked)" aria-label="External Rset" />
                <span id="AOC-rset-checkbox"></span>
            </label>
        </div>
        <div id="AOC-enable-section" *ngIf="isHiddenEnable" class="rSet">
            <label aria-hidden="true">
                Enable feature
                <input type="checkbox" [checked]="isEnable" name="Rset"
                class="primary-checkbox" id="enableAOC" (change)="enableChanged($event.target.checked)" aria-label="Enable feature" />
                <span id="AOC-enable-checkbox" class="extra-border-enablefeat"></span>
            </label>
        </div>
        <!--External-->
    </div>
    <span id="AOC-restoredefault-tooltip-trigger" class="col-1 aoc-tooltips" *ngIf="defaultColor===false">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div id="AOC-restoredefault-tooltip-text" class="col-9 title-tooltip">Restore default</div>
            </div>
        </ng-template>
    </span>
    <span id="AOC-default-tooltip-trigger" class="col-1 aoc-tooltips" *ngIf="defaultColor===true">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div id="AOC-default-tooltip-text" class="col-9 title-tooltip">Default</div>
            </div>
        </ng-template>
    </span>

    <div class="col-8"></div>
    <div class="col-1"></div>
</div>
<!-- <div class="row unit-container">
    <div class="col-2 custom-button"></div>
    <div class="col-9 unit">mA</div>
    <div class="col-1"></div>
</div> -->
<div id="aoc_current_container" class="row slider-container" [ngClass]="{'isResetDisabled': isAocDisable }">
    <div id="AOC-current-label" class="col-1 label signifyBookmd dim-margin">Current</div>
    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin">
                <span id="AOC-current-min" class=" signifyBookmd minValue"> min {{floorValue}}</span>
            </div>
            <div class="col-2">
                <span id="AOC-current-max" class="signifyBookmd maxValue"> max {{ceilValue}}</span>
            </div>
        </div>
    </div>

    <span [id]="'AOC-current-min'" class="signifyBookmd text-mindim  sliderMinValue col-1" *ngIf="!quickConfigvalue">{{floorValue}}</span>
    <div id="aoc_current_slider" class="col-6 curvePadding sliderCss" *ngIf="!quickConfigvalue"
        [ngClass]="{'disbaleStyle': isAocDisable }">
        <ngx-slider type="normalType" [options]=valOptions [(value)]=textboxValue
            (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="aocValuechange($event.value)" ngDefaultControl>
        </ngx-slider>
    </div>
    <span [id]="'AOC-current-max'" class="signifyBookmd text-mindim col-1" [ngClass]="{'maxValueCss': quickConfigvalue===true}"
        *ngIf="!quickConfigvalue">{{ceilValue}}</span>

    <div class="row form-group col-3">
        <input type="number" id="aoc_current_txtBox" [(value)]="this.ngModelval['AocCurrent']"
            (keypress)="numberOnly($event)" (input)="valueChanged($event.target.value)"
            [ngClass]="{'myStyle': inputError['AocCurrent']===true, 'disbaleStyleInput': isExternalRset || isEnable}"
            [disabled]="isAocDisable"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard" />
        <p id="AOC-current-unit" class="signifyBookmd" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">mA</p>
    </div>

</div>
<br>
